<template>
  <div class="care-label white rounded pa-8">
    <v-data-table
      :items="items"
      :headers="headers"
      :items-per-page="options.limit"
      :loading="loading"
      :min-height="530"
      hide-default-footer
    >
      <template #top>
        <div class="pa-4 d-flex">
          <h1 class="text-h6">
            Care Label
          </h1>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="options.search"
            dense
            outlined></v-text-field>
          <v-btn
            class="ml-2"
            @click="options.page = 1, getCareLabel()">
            SEARCH
          </v-btn>
        </div>
        <div class="ml-auto text-right">
          <v-btn
            color="secondary"
            @click="dialog = true">
            <v-icon>mdi-plus</v-icon>
            เพิ่ม Care Label
          </v-btn>
        </div>
      </template>
      <template #item.imageUrl="{ item }">
        <v-img
          class="ma-2 elevation-1"
          covered
          aspect-ratio="1"
          width="150px"
          :src="$convertImgix(`${item.imageUrl}?w=1024`)"
          alt=""
          @click="previewImg(item.imageUrl)">
        </v-img>
      </template>
      <template #item.actions="{ item }">
        <v-btn
          small
          class="mr-2"
          color="secondary"
          @click="formMode = 'edit', editValue = item, dialog = true">
          แก้ไข
        </v-btn>
        <v-btn
          dark
          small
          color="red"
          @click="deleteConfirm(item)">
          ลบ
        </v-btn>
      </template>
    </v-data-table>
    <v-pagination
      v-if="!loading"
      v-model="options.page"
      class="mt-4"
      :total-visible="15"
      :length="totalPage" />
    <img-popup-preview
      v-model="previewEnabled"
      :img-src="currentImgPreview" />
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      max-width="600px"
      transition="dialog-top-transition"
      @click:outside="resetForm()">
      <v-card class="white pa-4">
        <CareLabelForm
          :mode="formMode"
          :value="editValue"
          @onCancel="resetForm"
          @onSubmit="submitForm" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CareLabelForm from '../components/CareLabelForm.vue'
import CareLabelProvider from '@/resources/CareLabelProvider'
import ImgPopupPreview from '@/components/ImgModalPreview.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    CareLabelForm,
    ImgPopupPreview
  },
    data () {
        return {
            careLabelService: new CareLabelProvider(),
            formMode: 'create',
            loading: false,
            totalPage: 1,
            totalItem: 1,
            editValue: null,
            dialog: false,
            items: [],
            headers: [
                {
                    text: 'ชื่อประเภท',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'ตัวอย่าง Care Label',
                    sortable: false,
                    value: 'imageUrl'
                },
                {
                    text: 'Actions',
                    sortable: false,
                    value: 'actions'
                }
            ],
            options: {
                page: 1,
                limit: 10,
                sortBy: 'createdAt',
                sortOrder: 'desc',
                search: ''
            },
            previewEnabled: false,
            currentImgPreview: ''
        }
    },
    watch: {
      'options.page': {
        handler () {
          this.getCareLabel()
        },
        deep: true
      }
    },
    mounted () {
      this.getCareLabel()
    },
    methods: {
      ...mapActions({
        setModal: 'Components/setModal',
        setSnackbar: 'Components/setSnackbar'
      }),
      async createCareLabel (val) {
        return this.careLabelService.create(val)
      },
      async updateCareLabel (id, payload) {
        return this.careLabelService.updateById(id, payload)
      },
      async submitForm (val) {
        try {
          if (this.formMode === 'create') {
            await this.createCareLabel(val)
            this.resetDefaultPagination()
            await this.getCareLabel()
          } else if (this.formMode === 'edit') {
            const { name, imageUrl } = val
            await this.updateCareLabel(this.editValue.id, { name, imageUrl })
            await this.getCareLabel()
          }
          this.resetForm()
        } catch (error) {
          this.setSnackbar({
              value: true,
              message: `Error code ${error.code} : ${error.message}`,
              type: 'error'
            })
        }
      },
      resetForm () {
        this.dialog = false
        this.formMode = 'create'
        this.editValue = null
      },
      async getCareLabel () {
        this.loading = true
        try {
          const { data } = await this.careLabelService.pagination(this.options)
          this.items = data.results
          this.totalPage = data.pages
          this.totalItem = data.total
        } catch (error) {
          this.setSnackbar({
            value: true,
            message: `Error code ${error.code} : ${error.message}`,
            type: 'error'
          })
        } finally {
          this.loading = false
        }
      },
      previewImg (img) {
        this.currentImgPreview = img
        this.previewEnabled = !!this.currentImgPreview
      },
      deleteConfirm (item) {
        this.setModal({
          value: true,
          title: 'Remove care label',
          message: `Do you want to remove the ${item.name}`,
          confirmText: 'Remove',
          confirmType: 'error',
          cancelType: '',
          cancelText: 'Cancel',
          onConfirm: () => this.deleteCareLabel(item)
        })
      },
      async deleteCareLabel (item) {
        try {
          await this.careLabelService.deleteById(item.id)
          await this.getCareLabel()
        } catch (error) {
          this.setSnackbar({
            value: true,
            message: `Error code ${error.code} : ${error.message}`,
            type: 'error'
          })
        }
      },
      resetDefaultPagination () {
        this.options.search = ''
        this.options.page = 1
      }
    }
}
</script>
